import api from './api';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export function exportDateStamp() {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${now.getFullYear()}-${month}-${day}`;
}

export async function downloadInvoiceExport(params, filename) {
  const response = await api.get(`/bureau-invoices/export?${params}`, {
    responseType: 'blob',
    timeout: 120000,
  });
  const url = URL.createObjectURL(new Blob([response.data], { type: EXCEL_TYPE }));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}
